<template>
  <div class="container">
    <QueryFrame
    @handlePage="handlePage"
      @handlePageSize="handlePageSize"
     :count="count"
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>账户名:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.phone"></lk-input>
          </div>
          <div class="queryItem">
            <label>姓名:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select class="item" clearable v-model.trim="query.status">
              <lk-option v-for="item in [{name: '启用', id: 1}, {name: '停用', id: 2}]" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>角色:</label>
            <lk-select class="item" filterable clearable v-model.trim="query.roleId">
              <lk-option v-for="item in storeRoles" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
         <div class="btnContainer">
          <lk-button @click="addNew" icon='md-add' v-if="handlePermission('storeAccountAdd')" type='primary' >{{isSystemManager?'新建门店管理员': ' 新建账户'}}</lk-button>
          <lk-button @click="exportList" icon='md-add' v-if="handlePermission('storeAccountExport')" type='primary' >导出Excel</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import system from '@/services/system';
import utils from '@/libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'StoreAccountList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      systemManage: false,
      storeRoles: [], // 角色列表
      query: {
        phone: '',
        name: '',
        roleId: '',
        storeIdList: null,
        status: '',
      },
      columns: [
        { title: '账户ID', key: 'sysUserId', minWidth: 116 },
        { title: '账户名', key: 'sysUserPhone', minWidth: 116 },
        { title: '姓名', key: 'sysUserName', minWidth: 116 },
        { title: '门店名称', key: 'sysStoreName', minWidth: 116 },
        { title: '角色', key: 'roleStrList', minWidth: 116 },
        {
          title: '状态',
          key: 'sysUserStatus',
          minWidth: 116,
          render: (h, params) => (this.handlePermission('storeAccountEnableDisable') ? h('lk-switch', {
            props: {
              size: 'large',
              value: params.row.sysUserStatus === 1,
              loading: params.row.loading,
            },
            on: {
              'on-change': (flag) => {
                params.row.loading = true;
                const toggleFunction = flag ? system.userEnable : system.userDisable;
                const Message = flag ? '该用户已启用' : '该用户已禁用';
                toggleFunction({ sysUser: { id: params.row.sysUserId }, sysStore: { id: params.row.sysStoreId } }).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success(Message);
                    params.row.loading = false;
                  } else {
                    params.row.loading = false;
                    this.$Message.error(res.data.error);
                    this.getData();
                  }
                }).catch((err) => {
                  params.row.loading = false;
                  this.getData();
                  utils.handleError(err);
                });
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',
            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',
            }, '禁用'),
          ]) : h('span', params.row.sysUserStatus === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('storeAccountInfo') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'storeAccountInfo', params: { id: params.row.sysUserId } });
                },
              },
            }, '查看') : null,
            this.handlePermission('storeAccountEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'storeAccountEdit', params: { id: params.row.sysUserId } });
                },
              },
            }, '修改') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getRoleInfos() {
      system.storeListEnable({ type: 2, page: 1, size: 10000 }).then((res) => {
        const { data } = res.data;
        if (res.data.status === 200) {
          this.storeRoles = data.list;
          this.count = data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.$route.params.create ? this.params.create = true : this.params.create = '';

      system.storeUserList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.loading = false;

            // 处理总部角色 将id转为字符串
            const roleStrList = [];
            item.roleList && item.roleList.forEach((subItem) => {
              roleStrList.push(subItem.name);
            });
            // for (const subItem of item.roleList) {
            //   if (item.roleIdList.includes(subItem.id)) {
            //   }
            // }
            result.roleStrList = roleStrList.join(', ');
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handleSearch() {
    //   this.page = 1;
    //   this.getData();
    // },
    // handlePage(page) {
    //   this.page = page;
    //   this.getData();
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.getData();
    // },
    addNew() {
      this.$router.push({ name: 'storeAccountAdd' });
    },
    clear() {
      this.query = {
        phone: '',
        name: '',
        roleId: '',
        storeIdList: [],
        status: '',
      };
    },
    exportList() {
      this.$route.params.create ? this.params.create = true : this.params.create = '';
      const temp = utils.deepClone(this.params);
      delete temp.page;
      delete temp.size;
      system.storeListExport(temp).then((res) => {
        if (res.status === 200) {
          utils.downFile(res.data, `门店账户${utils.formatTime(new Date().getTime(), 'YYYYMMDD')}.xlsx`);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getRoleInfos();
    // this.getData();
    this.handleSearch(true);
  },
  computed: {
    isSystemManager() {
      const roleNames = [];
      this.$store.state.user.roles.forEach((item) => {
        roleNames.push(item.name);
      });
      return roleNames.includes('系统管理员');
    },
  },
};
</script>
<style lang="less" scoped>
.btnContainer{
  margin-bottom: 12px;
  margin-top:2px;
  >*:first-child{
    margin-right: 8px
  }

}
  .queryContainer{
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
</style>
